import { render, staticRenderFns } from "./SenderAdd.vue?vue&type=template&id=a4f22352&scoped=true"
import script from "./SenderAdd.vue?vue&type=script&lang=js"
export * from "./SenderAdd.vue?vue&type=script&lang=js"
import style0 from "./SenderAdd.vue?vue&type=style&index=0&id=a4f22352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f22352",
  null
  
)

export default component.exports